import z from "zod";

import { createAnnouncementAttachmentArgsSchema } from "./GoogleClassroomClientTypes";

export const codeSchema = z.string();
export type Code = z.infer<typeof codeSchema>;

export const googleOAuthUserSchema = z.object({
  accessToken: z.string(),
  loginHint: z.string(),
  refreshToken: z.string().optional(),
  profilePictureUrl: z.string().optional(),
  email: z.string().optional(),
});

export type GoogleOAuthUser = z.infer<typeof googleOAuthUserSchema>;

export const tokenPayloadSchema = z.object({
  token: z.string(),
});

export type TokenPayload = z.infer<typeof tokenPayloadSchema>;

export const CreateAttachmentCallSchema = z.tuple([
  createAnnouncementAttachmentArgsSchema,
  z.string().min(1), // accessToken
  z.string().min(1), // session
]);

export type CreateAttachmentCall = z.infer<typeof CreateAttachmentCallSchema>;
